export default "__VITE_ASSET__4632bdef__"